<template>
<v-card class="pa-2">
    <div class="detail font-weight-bold pa-0 ma-0">Roles</div>
    <div class="pa-2">
        <!-- SEARCH -->
        <div class="im-search my-2">
            <div class="d-flex">
                <v-text-field class="ma-0 mx-1 white pt-0" flat v-model="search" clearable placeholder="Type here to search by field ..." append-icon="search" hide-details></v-text-field>
                <v-btn class="mx-1" color="primary" outlined @click="openRoleDialog()" style="height: 30px">Add Role</v-btn>
            </div>
        </div>
        <!-- ./ SEARCH -->
        <!--data table-->
        <v-card tile flat class="mx-1">
            <v-row no-gutters align="center" class="secondary regular">
                <v-col cols="4" class="pa-2">Services</v-col>
                <v-col cols="8" class="pa-2">Roles</v-col>
            </v-row>
        </v-card>
        <!--./ data table -->
        <div class="mx-1" style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>
        <!-- DATATABLE ROWS -->
        <v-card tile flat class="mx-1" style="background-color: transparent !important;">
            <v-data-iterator :items="user_roles" :footer-props="{ itemsPerPageOptions }">
                <template v-slot:default="props">
                    <template v-for="(item,index_service) in props.items">
                        <v-row no-gutters align="center" class="secondary my-1 pa-2 regular">
                            <v-col cols="4" class="px-2">
                                <div>{{ item.service_name }}
                                </div>
                            </v-col>
                            <v-col cols="8">
                                <v-chip v-for="(role, index_role) in item.roles" :key="role.id" :style="{background: item.service_color}" close @click:close="deleteConfimationRole(index_service,index_role)">
                                    {{role.role_name}}
                                </v-chip>
                            </v-col>
                        </v-row>
                    </template>
                </template>
                <template v-slot:no-data>
                    <v-alert :value="true" type="info" color="primary">
                        No data available.
                    </v-alert>
                </template>
            </v-data-iterator>
        </v-card>
    </div>

    <!-- add new role dialog -->
    <v-dialog v-model="role_dialog" max-width="640px">
        <v-card flat tile color="#f5f5f5">
            <v-card-title class="important white--text primary" height="50">Add Role</v-card-title>

            <v-card-text class="pt-3">
                <im-search-services class="mb-3" @input="selectService($event)" ref="services" />
                <v-divider class="mb-2" />
                <v-text-field label="Name" v-model="service.name" readonly hide-details />
                <v-text-field label="Slug" v-model="service.slug" readonly hide-details />
                <v-autocomplete :items="roles" v-model="role" label="Roles" item-text="name" return-object />
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="exitDialogRoles()">Cancel</v-btn>
                <v-btn color="primary" @click="addRole()" :disabled="!role">Add Role</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- add new role dialog -->
</v-card>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from "../../utils/PropDefaults.js";
import SearchServices from "../../utils/SearchServices.vue";
import pinterest from "@/assets/pinterest.svg"

export default {

    props: {
        item_id: {
            type: [Number, String]
        },
        dialog: Boolean
    },

    components: {
        "im-search-services": SearchServices
    },
    data() {
        return {
            // dialogs modals
            delete_role_dialog: false,
            role_dialog: false,

            // role table and search
            loading: false,
            service: {},
            user_roles: [],
            role: null,
            roles: [],
            search: null,
            search_timeout: 500,
            total: 0,
            page: 1,
            size: 5,
            itemsPerPageOptions: [5, 10, 15, 20],

        };
    },

    computed: {},

    watch: {
        dialog: {
            handler() {
                this.user_roles = [];
                this.total = 0;
                this.page = 1;
                this.size = 5;
            }
        },
        search: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getUserRoles, 500);
            }
        },
        clean: {
            handler(old) {
                if(old == false) {
                    this.user_roles = []
                    this.user = this.$clone(defaults.user_item);
                }
            }
        },
        user_roles: {
            handler() {
                this.$emit('roles', this.user_roles);
            }
        }
    },

    beforeDestroy() {
        this.user = this.$clone(defaults.user_item);
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),



        exit() {
            this.user = this.$clone(defaults.user_item);
            this.$emit("exit")
        },

        getRoles() {
            // refresh roles
            this.roles = [];

            // construct params object
            let params = {
                params: {
                    //search: this.role,
                    service_ids: [this.service.id]
                }
            };

            // prepare endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/roles/roles";

            this.$axios.get(endpoint, params)
                .then(response => {
                    this.roles = response.data.data;
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        selectService(service) {
            if(service) {
                this.service = this.$clone(service);
            } else {
                this.service = {};
            }
            this.getRoles();
        },
        // role funtions
        openRoleDialog() {
            this.role_dialog = true;
        },

        exitDialogRoles() {
            this.role_dialog = false;
            this.service = {};
            this.roles = [];
            this.role = null;
            this.$refs.services.clear();
        },

        addRole() {
            if(this.user_roles.length > 0) {
                let index = this.user_roles.findIndex(item => item.service_id === this.service.id);

                if(index < 0) {
                    // create a new role with a different service
                    this.user_roles.push({
                        'service_color': this.service.color,
                        'service_id': this.service.id,
                        'service_name': this.service.name,
                        'service_slug': this.service.slug,
                        'roles': [{
                            'role_id': this.role.id,
                            'role_name': this.role.name,
                            'role_slug': this.role.slug,
                        }],
                    })
                    this.exitDialogRoles();
                } else {
                    let index_role = this.user_roles[index].roles.findIndex(item => item.role_id === this.role.id);
                    if(index_role < 0) {
                        // create a "unique" role
                        this.user_roles[index].roles.push({
                            'role_id': this.role.id,
                            'role_name': this.role.name,
                            'role_slug': this.role.slug,
                        })
                        this.exitDialogRoles();
                    } else {
                        // emit error because the role exist
                        this.error("Role already added");
                    }
                }
            } else {
                // first role added
                this.user_roles.push({
                    'service_color': this.service.color,
                    'service_id': this.service.id,
                    'service_name': this.service.name,
                    'service_slug': this.service.slug,
                    'roles': [{
                        'role_id': this.role.id,
                        'role_name': this.role.name,
                        'role_slug': this.role.slug,
                    }],
                })
                this.exitDialogRoles();
            }
        },

        deleteConfimationRole(index_service, index_role) {
            if(this.user_roles[index_service].roles.length === 1) {
                this.user_roles.splice(index_service, 1);
            } else {
                this.user_roles[index_service].roles.splice(index_role, 1);
            }
        },


    }
};
</script>

<style>
.pointer {
    cursor: pointer;
}
</style>
